module.exports = __webpack_public_path__ + "img/FAQ.0e1271d2.png";